import { IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface IIconButtonWithTooltip extends IconButtonProps {
  label: string;
  Icon: ReactElement;
}

export const IconButtonWithTooltip = ({ label, Icon, ...rest }: IIconButtonWithTooltip) => (
  <Tooltip label={label}>
    <IconButton icon={Icon} {...rest} />
  </Tooltip>
);
